import { render, staticRenderFns } from "./Scene15.vue?vue&type=template&id=30b3e670&scoped=true"
import script from "./Scene15.vue?vue&type=script&lang=js"
export * from "./Scene15.vue?vue&type=script&lang=js"
import style0 from "./Scene15.vue?vue&type=style&index=0&id=30b3e670&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b3e670",
  null
  
)

export default component.exports